import type { QuestionnaireState } from "../../types";

export const handleSetErrorAction = (
  state: QuestionnaireState,
  payload: { name: string; message: string },
): QuestionnaireState => {
  return {
    ...state,
    errors: {
      ...state.errors,
      [payload.name]: payload.message,
    },
    isValid: false,
  };
};
